import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
import performRequest from "../../api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import Footer from "../../Components/Footer/footer";
import StepRoutes from "../../Routes/steps_routes";
import LineGraph from "./Graph/log_graph";
import Pagination from "../../Components/layouts/pagination";
import getFilteredURL from "../../Components/Functions/filters.getUrl";

const HydrobuildLogs = () => {
  const location = useLocation()
  const itemIsActive = location.state?.itemIsActive
  let { uid } = useParams();
  const [allLogs, setLogs] = useState();
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({
  });
 
  useEffect(() => {

    // if (uid && itemIsActive) {
    if (uid) {

      performRequest("GET", getFilteredURL(`/hydrobuild/hydrobildalllogsbyuid/${uid}`,page, filters))
        .then((res) => {setLogs(res.data.filteredLogs)
          setTotalPages(Math.ceil(res.data.filterCount/50))
        })

        .catch((err) => CustomErrorResponse(err));
    }
  }, [uid,page]);

  useEffect(() => {

    // if (uid && itemIsActive) {
    if (uid) {

      performRequest("GET", `/hydrobuild/hydrobulidGraph/${uid}`)
        .then((res) => {
         
           setData(res.data.HydrobulidData)
        })

        .catch((err) => CustomErrorResponse(err));
    }
  }, [uid]);

  // const returnStyle = () => {
  //   return itemIsActive
  //   ? { pointerEvents: "auto", opacity: 1 }
  //   : { pointerEvents: "none", opacity: 0 };
  // };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  ALL Logs Of Hydrobuild:- {uid}
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="card">
              <div className="container mt-5">
                <div className="row mb-4">
                  <div className="col-md-6">
                    <h3>Temperature</h3>
                    <LineGraph
                      data={data}
                      label="Temp"
                      color="rgb(255, 99, 132)"
                    />
                  </div>
                  <div className="col-md-6">
                    <h3>Humidity</h3>
                    <LineGraph
                      data={data}
                      label="Hum"
                      color="rgb(54, 162, 235)"
                    />
                  </div>
                  <div className="col-md-6 mt-lg-2">
                    <h3>PH</h3>
                    <LineGraph
                      data={data}
                      label="pH"
                      color="rgb(75, 192, 192)"
                    />
                  </div>
                  <div className="col-md-6 mt-lg-2">
                    <h3>EC</h3>
                    <LineGraph
                      data={data}
                      label="EC"
                      color="rgb(153, 102, 255)"
                    />
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                {allLogs && (
                  <table className="table table-vcenter">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Time</th>
                        <th>Ph</th>
                         <th>EC (ppm)</th>
                        <th>Humidity</th>
                        <th>Temp</th>
                        
                        
                        {/* <th>Oxy-Pump</th> */}
                        <th>Ph-up</th>
                        <th>Ec-up</th>
                        <th>Ec-down</th>
                      </tr>
                    </thead>
                    <tbody>
                      
                      {allLogs?.map((lineItem, index) => {
                          const Index = (page - 1) * 50 + index + 1;
                        return (
                          <tr key={index}>
                            
                            <td>{Index}</td>
                            <td>{(lineItem?.Time || "N/A").toUpperCase()}</td>
                            <td>{!isNaN(Number(lineItem?.pH)) ? Number(lineItem.pH).toFixed(1) : "N/A"}</td>
                            <td>{(lineItem?.EC || "N/A").toUpperCase()}</td>
                            <td>{(lineItem?.Hum || "N/A").toUpperCase()}</td>
                            <td>{(lineItem?.Temp || "N/A").toUpperCase()}</td>
                            {/* <td>{lineItem?.oxy === "1" ? "On" : "OFF"}</td> */}
                            <td>{lineItem?.ph_up === "1" ? "On" : "OFF"}</td>
                            <td>{lineItem?.ec_up === "1" ? "On" : "OFF"}</td>
                            <td>{lineItem?.ec_dn === "1" ? "On" : "OFF"}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
               <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default HydrobuildLogs;
